module.exports = __webpack_public_path__ + "img/smw-library01.e276baf2.jpg";